module.exports = __webpack_public_path__ + "img/detention_watch.c6f93caa.svg";